var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgForkPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 276,
    viewBox: "0 0 227 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.969 197.33L101.703 197.954L101.046 197.787L96.7559 196.703C94.7988 196.209 93.3388 194.616 92.9325 192.666C91.051 183.633 83.2561 152.776 58.2241 112.806C42.1166 87.0863 28.3353 76.0793 23.2987 72.6124C21.8284 71.6004 20.8357 69.9322 20.8357 68.0884V65.1919V64.0002L21.935 64.4604L91.1774 93.4526L91.593 93.6266L91.6562 94.0727L105.184 189.506L105.215 189.725L105.128 189.928L101.969 197.33Z",
    fill: "#C9CED4",
    stroke: "#07284E",
    strokeWidth: 1.58599
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2993 59.8688L122.35 31.1843C125.238 30.3481 128.36 30.2919 131.2 31.5216C139.234 34.9996 157.482 45.2743 175.158 71.8548C201.23 111.06 207.69 137.839 209.246 147.24C209.674 149.819 208.2 152.187 205.875 153.203L104.256 197.604C101.713 198.715 98.8089 196.966 98.3601 194.307C96.6314 184.065 89.8119 156.281 63.3831 112.55C46.2127 84.1383 30.1724 70.9494 22.4907 65.7691C21.379 65.0194 20.9829 63.7103 21.1257 62.5665C21.2689 61.42 21.9812 60.2505 23.2993 59.8688Z",
    fill: "white",
    stroke: "#07284E",
    strokeWidth: 1.58599
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.549 196.965C102.307 197.222 103.149 197.221 103.938 196.877L205.557 152.476C207.585 151.589 208.825 149.553 208.464 147.369C206.926 138.081 200.509 111.407 174.498 72.2934C156.915 45.8524 138.792 35.6719 130.885 32.2488C130.188 31.947 129.47 31.7279 128.741 31.5835C139.006 36.6401 156.038 47.7458 171.054 70.3256C197.137 109.549 203.518 136.263 205.032 145.479C205.385 147.625 204.189 149.632 202.214 150.543L101.549 196.965Z",
    fill: "#DFE3E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8327 82.963C54.8419 81.8145 53.8364 80.6994 52.8474 79.6421C51.2045 77.8857 51.9056 74.9607 54.2002 74.2401L136.738 48.3223C138.555 47.7518 140.543 48.0129 142.072 49.1486C143.851 50.4706 145.728 52.0173 147.516 53.6719C149.212 55.2413 148.489 57.9682 146.285 58.6642L62.817 85.0294C60.2967 85.8255 57.5593 84.9642 55.8327 82.963Z",
    fill: "#C9CED4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.5 255.846C60.7932 255.846 18.0674 252.236 18.0674 247.782C18.0674 243.327 60.7932 239.718 113.5 239.718C166.207 239.718 208.933 243.327 208.933 247.782C208.933 252.236 166.207 255.846 113.5 255.846Z",
    fill: "rgba(0,0,0,0.2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForkPage);
export default __webpack_public_path__ + "static/media/fork_page.cd23906e.svg";
export { ForwardRef as ReactComponent };